<template>
  <div class="account-manage">
    <public-bread-crumb :routes='routes' />
    <public-top-bar
      placeholder="请输入用户姓名、手机号码"
      :topBarBtns='topBarBtns'
      :onTableSearchFun="onTableSearchFun"
      @changeBasicSearchFun="changeBasicSearchFun"
    />
    <public-table
      :columns='columns'
      :tableData="tableData"
      :tableInfo="tableInfo"
      :operateA="operateA"
      :operateWidth="operateWidth"
      :tableLoading="tableLoading"
      @selectTableRowFun="selectTableRowFun"
      @sortChangeFun="tableSorterFun"
      >
    </public-table>
    <public-del ref="delWeight" delDesc="删除后该账户不可再登录运维平台，且不可恢复，是否确定？" :btnLoading="btnLoading" :delTableDataFun="delTableDataFun" />
  </div>
</template>

<script>
import { publicTableList } from '@/mixins/mixinsData'
import AccountServices from '@/services/account.services'
export default {
  name: 'AccountManage',
  mixins: [publicTableList],
  data () {
    return {
      routes: [
        {
          name: '账号管理',
          path: '/system/account'
        }
      ],
      topBarBtns: [
        {
          name: '新增',
          type: 'primary',
          fun: this.addPageOrEditPage
        },
        {
          name: '删除',
          type: '',
          fun: this.topBarDelBtnFun
        },
        {
          name: '全选',
          type: '',
          fun: this.selectAllFun
        }
      ],
      columns: [
        {
          title: '用户姓名',
          dataIndex: 'name',
          width: 380
        },
        {
          title: '手机号码',
          dataIndex: 'account',
          width: 356
        },
        {
          title: '创建人',
          dataIndex: 'createName',
          width: 380,
          type: "tooltip",
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          type: 'YY-MM-DD hh:mm:ss',
          sorter: true
        }
      ],
      operateA: [
        {
          name: '编辑',
          fun: this.addPageOrEditPage
        },
        {
          name: '删除',
          fun: this.rowDel
        }
      ],
      operateWidth: 140
    }
  },
  mounted () {
    // this.getTableData(AccountServices.GetAccountTable)
    // // 获得删除接口
    // this.tableServices.delServices = AccountServices.Delete
  },
  // 缓存组件激活
  activated () {
    this.getTableData(AccountServices.GetAccountTable)
    // 获得删除接口
    this.tableServices.delServices = AccountServices.Delete
  },
  // 缓存组件停用
  deactivated () {},
  methods: {
    // 编辑?新增?
    addPageOrEditPage (item) {
      if (item && item.id) {
        this.$router.push(`/system/modify-form?id=${item.id}`)
      } else {
        this.$router.push('/system/modify-form')
      }
    }
  }
}
</script>

<style lang="less" scoped>

</style>
